import { createContext, useContext } from 'react';

 
import { LanguageList } from '../language';

type LanguageContextType = {
  language: LanguageList | undefined;
  changeLanguage: (language: LanguageList) => void;
  getLocale: (language: LanguageList) => string;
};

export const LanguageContext = createContext<LanguageContextType>({
  language: undefined,
  changeLanguage: () => null,
  getLocale: () => 'en',
});

export const useLanguage = (): LanguageContextType =>
  useContext(LanguageContext);
